import {get, post} from '@/request/http'

//获取部门列表
export const getdepts = (params) => get('/api/admin/getdepts', params)
//获取部门列表2
export const getdepts2 = (params) => get('/api/admin/getdepts2', params)

//添加部门
export const adddept = (params) => post('/api/admin/adddept', params)

//编辑部门
export const updateDept = (params) => post('/api/admin/updatedept', params)
//删除部门
export const deletedept = (params) => post('/api/admin/deletedept', params)


//获取团队列表
export const getadminusers = (params) => get('/api/admin/getadminusers', params)


//获取项目列表
export const getprojects = (params) => get('/api/admin/getprojects', params)

//添加项目
export const addproject = (params) => post('/api/admin/addproject', params)

//删除项目
export const deleteaproject = (params) => post('/api/admin/deleteproject', params)

//编辑项目
export const updateproject = (params) => post('/api/admin/updateproject', params)

//获取单个项目
export const getprojectbyid = (params) => get('/api/admin/getprojectbyid', params)


//获取分组列表
export const getgroups = (params) => get('/api/admin/getgroups', params)

//添加分组
export const addgroup = (params) => post('/api/admin/addgroup', params)

//编辑分组
export const updategroup = (params) => post('/api/admin/updategroup', params)
//删除分组
export const deleteagroup = (params) => post('/api/admin/deletegroup', params)

//获取状态列表
export const getstatuss = (params) => get('/api/admin/getstatuss', params)

//删除状态
export const deletestatus = (params) => post('/api/admin/deletestatus', params)
//编辑状态
export const updatestatus = (params) => post('/api/admin/updatestatus', params)

//增加状态
export const addstatus = (params) => post('/api/admin/addstatus', params)
//获取角色列表
export const getRoleList = (params) => get('/api/admin/getroles', params)
//获取角色列表
export const getRoleList2 = (params) => get('/api/admin/getroles2', params)
//新增角色
export const addRole = (params) => post('/api/admin/addrole', params)
//编辑角色
export const editRole = (params) => post('/api/admin/updaterole', params)
//删除角色
export const delRole = (params) => post('/api/admin/deleterole', params)


//获取用户列表
export const getUserList = (params) => get('/api/admin/getadminusers', params)

export const getUserList2=(params)=> get('/api/admin/getadminusers2',params)
//新增用户
export  const addUser=(params) => post('/api/admin/addadminuser',params)
//编辑用户
export  const editUser=(params) => post('/api/admin/updateadminuser',params)
//删除用户
export const delUser=(params) => post('/api/admin/deleteadminuser',params)



// WEBPACK FOOTER //
// ./src/api/setting.js